import React from "react";
import { Box, Text, Stack } from "@chakra-ui/react";

import { Paper } from "#app/components/index.jsx";

export const List = ({ children, ...props }) => {
  return (
    <Stack spacing="5" {...props}>
      {children}
    </Stack>
  );
};

export const ListItem = ({ children, ...props }) => {
  return (
    <Stack
      direction={{ base: "column", lg: "row" }}
      spacing={{ base: "5", lg: "8" }}
      justify="space-between"
      {...props}
    >
      {children}
    </Stack>
  );
};

export const ListItemHeader = ({
  title,
  titleProps = {},
  subtitle = null,
  subtitleProps = {},
  ...props
}) => {
  return (
    <Box flexShrink={0} {...props}>
      <Text
        fontSize="lg"
        fontWeight="medium"
        w={{ base: "100%", lg: "350px" }}
        {...titleProps}
      >
        {title}
      </Text>
      {subtitle &&
        (typeof subtitle === "function" ? (
          subtitle({
            color: "subtle",
            fontSize: "sm",
            w: { base: "100%", lg: "350px" },
          })
        ) : (
          <Text
            color="subtle"
            fontSize="sm"
            w={{ base: "100%", lg: "350px" }}
            {...subtitleProps}
          >
            {subtitle}
          </Text>
        ))}
    </Box>
  );
};

export const ListItemContent = ({ Component = Paper, children, ...props }) => {
  if (React.isValidElement(Component)) {
    return React.cloneElement(Component, {
      p: { base: 4, md: 8 },
      w: "100%",
      ...props,
    });
  }

  return (
    <Component p={{ base: 4, md: 8 }} w="100%" {...props}>
      {children}
    </Component>
  );
};
